import {
  BooleanInput,
  NumberInput,
  useRecordContext,
  SaveButton,
  SimpleForm,
  Edit,
} from 'react-admin';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Card,
  Toolbar,
  styled,
} from '@material-ui/core';
import { CardContent, Typography } from '@mui/material';
import React from 'react';

const ConfigEditToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const Config = () => {
  const ProviderView = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <pre>{JSON.stringify(record.provider, null, '\t')}</pre>;
  };

  return (
    <Card>
      <CardContent>
        <ProviderView />
        <Edit
          title="Config"
          resource="config"
          actions={false}
          id="config"
          mutationMode="pessimistic"
        >
          <SimpleForm toolbar={<ConfigEditToolbar />}>
            <BooleanInput
              source="csbEnabled"
              label="Indicates whether the Cashback redemption feature is enabled globally for all users"
            />
            <BooleanInput
              source="gcdEnabled"
              label="Indicates whether the Gift Cards redemption feature is enabled globally for all users"
            />
            <Table>
              <TableBody>
                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      The gift card conversion rate for reward points per 1£.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput source="giftCardRpRate" label={false} />
                  </TableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      The cashback conversion rate for reward points per 1£.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput source="csbRpRate" label={false} />
                  </TableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      Total £ amount available for rewards redemption today.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput source="dailyGbpSpendCap" label={false} />
                  </TableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      Total £ amount available for rewards redemption this
                      month.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput source="monthlyGbpSpendCap" label={false} />
                  </TableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      The maximum amount of £ allowed to spend daily by one
                      user.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput source="dailyGbpUserSpendCap" label={false} />
                  </TableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      The maximum amount of £ allowed to spend monthly by one
                      user.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput
                      source="monthlyGbpUserSpendCap"
                      label={false}
                    />
                  </TableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      The number of reward points a user receives when they
                      subscribe.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput source="initialRp" label={false} />
                  </TableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <TableCell>
                    <Typography variant="body1">
                      The waiting period (in days) after a user subscription is
                      canceled before their reward points are revoked.
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <NumberInput
                      source="waitPeriodUntilRevokeRp"
                      label={false}
                    />
                  </TableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </SimpleForm>
        </Edit>
      </CardContent>
    </Card>
  );
};
